<template>
  <expandable-card>
    <template #default="{ isExpanded }">
      <v-card-title v-if="isExpanded">
        {{ $t('views.technicalDirector.titles.techniciansList') }}
        <v-spacer />
        <v-text-field
          v-model="search"
          :label="$t('views.technicalDirector.search')"
          single-line
          hide-details
          clearable
          clear-icon="$fas fa-xmark"
          prepend-inner-icon="$fas fa-search"
        />
      </v-card-title>

      <v-data-table
        :custom-sort="sortByKpiRiskAndDate"
        :dense="!isExpanded"
        :headers="headers"
        :items="items"
        :items-per-page="-1"
        :search="search"
        :sort-desc="true"
        class="row-pointer overflow-auto"
        fixed-header
        height="100%"
        hide-default-footer
        item-key="id"
        sort-by="kpi"
        @click:row="(item) => onTechnicianClicked(item)"
      >
        <template #[`item.weather`]="{ item }">
          {{ mixin_formatWeather(item) }}
        </template>
        <template #[`item.kpi`]="{ item }">
          <TrendChip
            :risk="item.kpi.risk"
            :date="item.kpi.date"
          />
        </template>
      </v-data-table>
    </template>
  </expandable-card>
</template>

<script>
import ExpandableCard from '@/components/core/ExpandableCard.vue'
import TrendChip from '../Charts/TrendChip.vue'
import customSortMixin from '@/mixins/customSortMixin'
import technicalManagerMixin from '@/mixins/technicalManagerMixin'

export default {
  name: 'TDTechnicians',
  components: {
    ExpandableCard,
    TrendChip,
  },
  mixins: [customSortMixin, technicalManagerMixin],
  props: {
    items: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      search: '',
    }
  },

  computed: {
    headers() {
      return [
        {
          text: this.$t('views.technicalDirector.headers.technician'),
          value: 'name',
        },
        {
          text: this.$t('views.technicalDirector.headers.project'),
          value: 'project',
        },
        {
          text: this.$t('views.technicalDirector.headers.weather'),
          value: 'weather',
        },
        {
          text: this.$t('views.technicalDirector.headers.kpi'),
          value: 'kpi',
        },
      ]
    },
  },

  methods: {
    onTechnicianClicked(item) {
      const routeData = this.$router.resolve({
        path: '/dashboard/site-control-technician',
        query: {
          project: item.kpi.project,
          user: item._id,
          date: item.date,
        },
      })
      window.open(routeData.href, '_blank')
    },
  },
}
</script>
